import { useEffect, type ReactNode } from 'react';
import Ikon from './Ikon';
import { useGeriKapat } from './mobil';

/**
 * ALT SAYFA — telefonda alttan açılan kısa katman (süzgeç, işlem listesi, aşama seçimi).
 * Geri tuşu ve perdeye dokunma kapatır; arkadaki sayfa kaymaz (ui/mobil.ts).
 * `tam`: uzun içerik için ekranın tamamını kaplar.
 */
export default function AltSayfa({ baslik, alt, kapat, children, eylem, tam }: {
  baslik: string; alt?: ReactNode; kapat: () => void; children: ReactNode;
  /** Altta yapışkan duran eylem satırı (ör. "Uygula"). */
  eylem?: ReactNode; tam?: boolean;
}) {
  useGeriKapat(true, kapat);
  useEffect(() => {
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape') { e.stopPropagation(); kapat(); } };
    document.addEventListener('keydown', esc);
    return () => document.removeEventListener('keydown', esc);
  }, [kapat]);
  return (
    <div className="ccd-altsayfa-perde" onClick={kapat} role="presentation">
      <div className={`ccd-altsayfa${tam ? ' ccd-altsayfa-tam' : ''}`} role="dialog" aria-modal="true" aria-label={baslik} onClick={(e) => e.stopPropagation()}>
        <div className="ccd-altsayfa-ust">
          <div style={{ minWidth: 0 }}>
            <h2 className="ccd-altsayfa-baslik">{baslik}</h2>
            {alt && <div className="ccd-meta">{alt}</div>}
          </div>
          <button type="button" className="ccd-ust-btn" onClick={kapat} aria-label="Kapat"><Ikon ad="kapat" boy={20} /></button>
        </div>
        <div className="ccd-altsayfa-govde">{children}</div>
        {eylem && <div className="ccd-altsayfa-eylem">{eylem}</div>}
      </div>
    </div>
  );
}
